<template>
  <el-select filterable
             class="select-default icon-autocomplete"
             :placeholder="$t('generic.icon')"
             :value="value"
             v-bind="$attrs"
             v-on="$listeners"
  >
    <template v-slot:prefix>
      <component :is="value" class="prefix-icon"></component>&nbsp;
    </template>
    <el-option v-for="icon in iconList"
               :value="icon"
               :label="getLabel(icon)"
               :key="icon"
               class="select-default">
      <div class="flex items-center">
        <component :is="icon" class="w-5 h-5 mr-2"></component>&nbsp;
        <span>{{getLabel(icon)}}</span>
      </div>
    </el-option>
  </el-select>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import * as featherIcons from 'vue-feather-icons'
  export default {
    name: 'icon-autocomplete',
    inheritAttrs: false,
    props: {
      value: String
    },
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ...featherIcons
    },
    data() {
      return {
        iconList: Object.keys(featherIcons)
      }
    },
    methods: {
      getLabel(icon) {
        return icon.replace('Icon', '')
      }
    }
  }
</script>

<style lang="scss">
  .icon-autocomplete {
    .prefix-icon {
      width: 16px;
      height: 16px;
    }
  }
</style>
